// extracted by mini-css-extract-plugin
export const landingPage = "landing-page-module--landingPage--1I9yE";
export const logo = "landing-page-module--logo--2NmOk";